export default __webpack_public_path__ + "static/media/banco-estado.617e3a4d.png";